<template>
  <button
    @click="selectNewOffer(item.name)"
    class="tw:rounded-xl tw:border tw:p-4"
    :class="getClasses"
    :data-testid="`hotel-offer-modal-item-${item.name}`"
  >
    <label
      class="tw:flex tw:flex-row tw:items-center tw:p-0 tw:m-0"
      :class="isClickable ? 'tw:hover:cursor-pointer' : 'tw:hover:cursor-default'"
    >
      <div class="tw:flex tw:items-center tw:justify-start tw:gap-x-3 tw:w-full">
        <img class="tw:h-[36px] tw:w-[36px]" :src="icons[item.name]" :alt="$t(`ho_${item.name}_title`)" />
        <div class="tw:flex tw:flex-col tw:justify-start tw:items-start tw:grow">
          <p class="tw:text-left tw:font-bold">{{ $t(`ho_${item.name}_title`) }}</p>
          <p class="tw:text-left tw:text-sm">
            {{ $t(`ho_${item.name}_text`) }}
          </p>
        </div>
        <img
          class="tw:justify-end tw:flex"
          :src="BlueTick"
          :alt="selectedItem?.name"
          v-if="selectedItem?.name === item.name"
        />
      </div>
      <input
        type="radio"
        :name="item.name"
        :value="selectedItem?.name"
        :id="item.name"
        :checked="selectedItem?.name === item.name"
        class="tw:hidden"
      />
    </label>
  </button>
</template>
<script setup>
import { computed } from 'vue'
const BlueTick = new URL('/src/assets/img/landing/icons/blue_tick.svg', import.meta.url)

import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId } from '@/layouts/queries'

const emit = defineEmits(['selectOffer'])
const selectNewOffer = offerName => {
  if (props.isClickable) {
    if (props.selectedItem === null || props.selectedItem?.name !== offerName) {
      appAnalytics.track(appAnalytics.events.HO_OFFER_CLICKED, {
        accommodationId: selectedAccommodationId.value,
        selectedOffer: offerName,
        source: 'Offer Setup Step 1',
      })
      emit('selectOffer', offerName)
    }
  }
}

const props = defineProps({
  item: Object,
  selectedItem: Object,
  icons: Object,
  isClickable: Boolean,
})

const getClasses = computed(() => {
  const classes = []
  if (props.selectedItem?.name === props.item.name) {
    classes.push('tw:border-blue-700 tw:bg-blue-100 tw:hover:cursor-default')
  } else {
    props.isClickable
      ? classes.push('tw:border-gray-300 tw:bg-white tw:hover:cursor-pointer')
      : classes.push('tw:border-gray-300 tw:bg-white tw:hover:cursor-default')
  }
  return classes.join(', ')
})
</script>
